export class ChatbotMessage {

    constructor(
        public text?: string,
        public origin?: string,
        public options?: Array<any>,
        public timestamp?: Date
    ){}
}


// WEBPACK FOOTER //
// ./src/app/components/base/vo/chatbot-message.ts